import { createContext, useContext } from 'react';

const ExportContext = createContext(false);

export const ExportProvider = ExportContext.Provider;

export const useIsExport = () => useContext(ExportContext);
